// @ts-ignore
import * as errorToolTip from '../errorToolTip.js';
import { Localization } from '../../localization/localization';
import { JsFormResponseHandlerObject, JsFormBeforeSendObject } from '../modules/jsFormTypes.js';
import { JRpcErrorStruct } from '../modules/jsonRpc/jRpcErrResponse.js';
import { TooltipDirection } from '../newErrorToolTip';
import { resetEmailPassword, ResetEmailPasswordRequest } from '../modules/newPassword/resetEmailPassword';
import { ResetEmailPasswordResponse } from '../../api/hub-responses/reset-email-password-response';
import { FormHandlers } from '../modules/formHandlers';

let sendingBlocked = false;

FormHandlers.registerAfterSendHandler('restore_form_handler', restoreFormHandler);
FormHandlers.registerBeforeSendHandler('before_restore_form', beforeRestoreSendHandler);
FormHandlers.registerSendRequestHandler('restore_form_send_request', restoreFormSendRequest);

function beforeRestoreSendHandler(data: JsFormBeforeSendObject) {
    if (sendingBlocked) {
        const input = $('input[name=email]', data.form).parent();
        console.log(data.caller);
        let toolTipDirection;

        if (data.form.parents('.forms2').length) {
            toolTipDirection = TooltipDirection.RIGHT;
        } else {
            toolTipDirection = TooltipDirection.LEFT;
        }

        errorToolTip(input, toolTipDirection, Localization._n('restore_form.wait_30'));
        return false;
    }

    return true;
}

type RestorePassResponse = {
    message?: string;
    error?: JRpcErrorStruct;
};

function restoreFormHandler(data: JsFormResponseHandlerObject<RestorePassResponse>) {
    const response = data.response;
    let toolTipDirection = TooltipDirection.RIGHT;
    const input = $('input[name=email]', data.form).parent();

    if (!response.error) {
        const $closeButton = $('.js-close-button', data.form.parent());
        const sendAgainButton = $(data.form).find('.restore-form__restore-button');

        $('.js-response', data.form).text(response.message);
        $closeButton.bind('click.restoreReset', function() {
            $('.js-response', data.form).text(Localization._n('restore_pass'));
            $closeButton.unbind('click.restoreReset');
        });
        input.removeClass('error');
        sendingBlocked = true;

        sendAgainButton
            // TODO заменить на специальный ключ для восстановления
            .text(Localization._n('ecommpay.button_to_retry'))
            .hide();

        if (data.form.parents('.forms2').length) {
            sendAgainButton
                .addClass('t-size-13');
        }
        setTimeout(() => {
            sendingBlocked = false;
            sendAgainButton.show();
        }, 1000 * 30);
    } else {
        if (data.form.parents('.forms2').length) {
            toolTipDirection = TooltipDirection.RIGHT;
        } else {
            toolTipDirection = TooltipDirection.LEFT;
        }

        errorToolTip(
            input,
            toolTipDirection,
            response.error.message
        );

        input.addClass('error');
    }
}

function restoreFormSendRequest(form: JQuery): Promise<ResetEmailPasswordResponse> {
    const email = $(form).find('input[name=email]')
        .val()
        .toString()
        .trim();
    const newPasswordRequest: ResetEmailPasswordRequest = {
        email,
        locale: window.app.config.locale
    };
    return resetEmailPassword(newPasswordRequest);
}
